module.exports = __webpack_public_path__ + "img/178.0bf9f133.jpg";